import { IBet, IUserTicket } from '@libs/interfaces';
import { createAction, props } from '@ngrx/store';


export const resetTicket = createAction(
  '[Bookmarks] reset ticket',
  props<{ ticket: Partial<IUserTicket> }>()
);

export const addBetTicket = createAction(
  '[Bookmarks] add bet ticket',
  props<{ bet: Partial<IBet> }>()
);

export const removeBetTicket = createAction(
  '[Bookmarks] remove bet ticket',
  props<{ bet: Partial<IBet> }>()
);

export const addBookmarks = createAction(
  '[Bookmarks] add bookmarks',
  props<{ bookmarks: IUserTicket[] }>()
);

export const addTicketBookmarks = createAction(
  '[Bookmarks] add ticket bookmark',
  props<{ ticket: IUserTicket }>()
);

export const removeTicketBookmarks = createAction(
  '[Bookmarks] remove ticket bookmark',
  props<{ ticket: IUserTicket }>()
);

export const addBookmarkJob = createAction(
  '[Bookmarks] Ticket add job',
  props<{ ticket: IUserTicket }>()
);